import { EGDSSpacing } from '@egds/react-core/spacing';
import * as React from 'react';
import { RefTarget } from '@shared-ui/ref-context';
import { InquiryProminence } from 'src/common/__generated__/api';
import { SharedUiContactHostWrapper } from '../shared-ui/offers/contact-host-wrapper';
import { SimpleLazyLoadWrapper } from 'src/common/components/common/lazy/simple-lazy-load-wrapper';
export const PropertyContactHostWrapper = () => React.createElement(EGDSSpacing, {
  margin: {
    block: 'six'
  }
}, React.createElement(RefTarget, {
  name: "ContactHost",
  tabIndex: 0
}, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(SharedUiContactHostWrapper, {
  prominence: InquiryProminence.MEDIUM
}))));